// jaride-412615 browser key, recovered from the pre-incident production build
// (main.b0f942f8.chunk.js: googleMapsApiKey). Same key FirebaseConfig already
// carries; it is a client-side key, restricted by HTTP referrer at Google.
export const GoogleMapApiConfig = 'AIzaSyAk4UsytAMFtpOKN3-vmePdzdZRWGvSZds';
